/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserMissionItemModel } from './UserMissionItemModel';
import {
    UserMissionItemModelFromJSON,
    UserMissionItemModelFromJSONTyped,
    UserMissionItemModelToJSON,
} from './UserMissionItemModel';

/**
 * ユーザーが持つミッション情報をミッションタイプごとに整理して管理するためのモデル
 * @export
 * @interface UserMissionItemsModel
 */
export interface UserMissionItemsModel {
    /**
     * ウィークリーミッションの開始曜日(0が日曜日)
     * @type {number}
     * @memberof UserMissionItemsModel
     */
    startDayOfWeeklyMission?: number;
    /**
     * APIアクセスタイミングがウィークリーミッションの開始曜日であるか否か
     * @type {boolean}
     * @memberof UserMissionItemsModel
     */
    isStartDayOfWeeklyMission?: boolean;
    /**
     * チュートリアルミッションのリスト
     * @type {Array<UserMissionItemModel>}
     * @memberof UserMissionItemsModel
     */
    tutorialMissionList?: Array<UserMissionItemModel>;
    /**
     * デイリーミッションのリスト
     * @type {Array<UserMissionItemModel>}
     * @memberof UserMissionItemsModel
     */
    dailyMissionList?: Array<UserMissionItemModel>;
    /**
     * 週間ミッションのリスト
     * @type {Array<UserMissionItemModel>}
     * @memberof UserMissionItemsModel
     */
    weeklyMissionList?: Array<UserMissionItemModel>;
    /**
     * 月間ミッションのリスト
     * @type {Array<UserMissionItemModel>}
     * @memberof UserMissionItemsModel
     */
    monthlyMissionList?: Array<UserMissionItemModel>;
    /**
     * 年間ミッションのリスト
     * @type {Array<UserMissionItemModel>}
     * @memberof UserMissionItemsModel
     */
    yearlyMissionList?: Array<UserMissionItemModel>;
    /**
     * キャンペーンミッションのリスト
     * @type {Array<UserMissionItemModel>}
     * @memberof UserMissionItemsModel
     */
    campaignMissionList?: Array<UserMissionItemModel>;
    /**
     * 上記以外のタイプであるミッションのリスト
     * @type {Array<UserMissionItemModel>}
     * @memberof UserMissionItemsModel
     */
    noneMissionList?: Array<UserMissionItemModel>;
}

/**
 * Check if a given object implements the UserMissionItemsModel interface.
 */
export function instanceOfUserMissionItemsModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserMissionItemsModelFromJSON(json: any): UserMissionItemsModel {
    return UserMissionItemsModelFromJSONTyped(json, false);
}

export function UserMissionItemsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMissionItemsModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startDayOfWeeklyMission': !exists(json, 'startDayOfWeeklyMission') ? undefined : json['startDayOfWeeklyMission'],
        'isStartDayOfWeeklyMission': !exists(json, 'isStartDayOfWeeklyMission') ? undefined : json['isStartDayOfWeeklyMission'],
        'tutorialMissionList': !exists(json, 'tutorialMissionList') ? undefined : ((json['tutorialMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
        'dailyMissionList': !exists(json, 'dailyMissionList') ? undefined : ((json['dailyMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
        'weeklyMissionList': !exists(json, 'weeklyMissionList') ? undefined : ((json['weeklyMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
        'monthlyMissionList': !exists(json, 'monthlyMissionList') ? undefined : ((json['monthlyMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
        'yearlyMissionList': !exists(json, 'yearlyMissionList') ? undefined : ((json['yearlyMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
        'campaignMissionList': !exists(json, 'campaignMissionList') ? undefined : ((json['campaignMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
        'noneMissionList': !exists(json, 'noneMissionList') ? undefined : ((json['noneMissionList'] as Array<any>).map(UserMissionItemModelFromJSON)),
    };
}

export function UserMissionItemsModelToJSON(value?: UserMissionItemsModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startDayOfWeeklyMission': value.startDayOfWeeklyMission,
        'isStartDayOfWeeklyMission': value.isStartDayOfWeeklyMission,
        'tutorialMissionList': value.tutorialMissionList === undefined ? undefined : ((value.tutorialMissionList as Array<any>).map(UserMissionItemModelToJSON)),
        'dailyMissionList': value.dailyMissionList === undefined ? undefined : ((value.dailyMissionList as Array<any>).map(UserMissionItemModelToJSON)),
        'weeklyMissionList': value.weeklyMissionList === undefined ? undefined : ((value.weeklyMissionList as Array<any>).map(UserMissionItemModelToJSON)),
        'monthlyMissionList': value.monthlyMissionList === undefined ? undefined : ((value.monthlyMissionList as Array<any>).map(UserMissionItemModelToJSON)),
        'yearlyMissionList': value.yearlyMissionList === undefined ? undefined : ((value.yearlyMissionList as Array<any>).map(UserMissionItemModelToJSON)),
        'campaignMissionList': value.campaignMissionList === undefined ? undefined : ((value.campaignMissionList as Array<any>).map(UserMissionItemModelToJSON)),
        'noneMissionList': value.noneMissionList === undefined ? undefined : ((value.noneMissionList as Array<any>).map(UserMissionItemModelToJSON)),
    };
}

